/**
 * Optional prefix for query keys so you can invalidate broad slices, e.g.
 * `queryClient.invalidateQueries({ queryKey: apiQueryRoot() })`.
 */
export const API_QUERY_ROOT = ["api"] as const;

export function apiQueryRoot(): readonly ["api"] {
  return API_QUERY_ROOT;
}

/** Build a typed query key under the api root. */
export function apiQueryKey<T extends readonly unknown[]>(
  ...parts: T
): readonly [...typeof API_QUERY_ROOT, ...T] {
  return [...API_QUERY_ROOT, ...parts];
}
